import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Japanese My Number validator following Single Responsibility Principle
 */
export class JpValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Japanese My Number',
      pattern: /^\d{12}$/,
      length: 12
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'My Number must be exactly 12 digits'
    );
  }

  validateChecksum(id) {
    const weights = [6, 5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 11; i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    const remainder = sum % 11;
    let expectedChecksum;

    if (remainder <= 1) {
      expectedChecksum = 0;
    } else {
      expectedChecksum = 11 - remainder;
    }

    const actualChecksum = parseInt(id[11]);
    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid My Number checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid My Number');
  }
}